<template>
  <div class="class-records">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="myData.length"
      class="layout"
    >
      <br>
      <ListOfClassLearners
        :learners="myData"
        @announcementdeletion="announceDeletion"
        />
    </div>
    <div
      v-else
      class="card"
    >
      <p>No learner records added, Add/create to get started </p>
      <Spinner />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'

// component imports
import ListOfClassLearners from '@/components/ListOfClassLearners.vue'
import Spinner from '@/components/Spinner.vue'

export default {
  name: 'Home',
  props: ['classTeacher'],
  components: { ListOfClassLearners, Spinner },
  setup (props, context) {
    const { myData, error, load } = getPosts()

    const announceDeletion = (edit) => {
      context.emit('toasts')
      load(props.classTeacher.state.grade + '/reports/teacher')
      if (edit) {
        context.emit('toasts', { edit: true })
      }
    }

    load(props.classTeacher.state.grade + '/reports/teacher')

    return { myData, error, announceDeletion }
  }
}
</script>

<style>
  .class-records {
    max-width: 960px;
    margin: 0 auto;
    padding: 10px;
  }
</style>
